const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};


export default {
    listar: async () => {
      try {
        const req = await fetch(`${BASE_API}site/academia`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
    cadastrar: async (data) => {
      try {
        let req;
        req = await fetch(`${BASE_API}site/academia`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data) 
        });
        
        const json = await req.json()
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    listarPorUserId: async (userId, token) => {
      try {
        const req = await fetch(`${BASE_API}academia/aluno/`+userId+`?token=`+token, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
};